// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__QuBr9","author":"Table_author__2GSUx","authorImage":"Table_authorImage__svV3I","unreadRow":"Table_unreadRow__276O-"};